import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=406cd3ec&scoped=true&"
import script from "./DynamicForm.vue?vue&type=script&lang=js&"
export * from "./DynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&id=406cd3ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406cd3ec",
  null
  
)

export default component.exports